import React, {Component} from "react";
import {connect} from "react-redux";
import {Field, reduxForm} from "redux-form";
import {Link} from "react-router-dom";
import CryptoJS from "crypto-js";
//image
import vuepay_large_logo from "../../assets/images/vuepaylogonav@5x.png";
import loading_white from "../../assets/gif/loading_white.gif";
//internal js
import * as actions from "../../actions/index";
import {checkIfLoggedIn, renderField} from "../../util/account_management";
import {isEmpty, vuepayAlert} from "../../util/utility";
import ModelTemp from "../../components/modal/ModelTemp";
import {getData, LOGIN, redirectIfSessionExist, setData,} from "../../util/storage";
import {doMoneyBloxLogin} from "../../assets/libs/MoneyBlox";
import {get as _get} from "lodash";
import sb_util from "../../util/sb/util";

class Login extends Component {
    required = (value) => (value ? undefined : "Required");

    constructor(props) {
        super(props);
        this.state = {
            type: "password",
            class_name: "btn btn-pwd-hide",
            moneyBloxData: null,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.showHidePassword = this.showHidePassword.bind(this);
  }

    componentDidMount() {
        document.getElementsByClassName("modal-overlay")[0].style.display =
            "inherit";
        redirectIfSessionExist((is_session_valid) => {
            if (is_session_valid) {
                this.props.history.push("/dashboard");
            }
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (checkIfLoggedIn(nextProps)) {
            //if the status_code received from the server is 200 means the user has successfully logged in
            if (nextProps.account_management.login.status_code === 200) {
                vuepayAlert(
                    "success",
                    nextProps.account_management.login.message,
                    () => {
                        setData(LOGIN, nextProps.account_management.login.data);
                        sb_util.sendBirdLogin("user")
                        if (nextProps.account_management.login.data.phone_number_validated === 1) {
                            nextProps.history.push("/verify-otp", {
                                country_code:
                                nextProps.account_management.login.data.country_code,
                                mobile_number:
                                nextProps.account_management.login.data.phone_number,
                                phone_number_validated: true,
                                api_token: nextProps.account_management.login.data.api_token,
                                token: nextProps.account_management.login.data.token,
                                parentPath: {
                                    basePath: nextProps.history.location.state.basePath,
                                    search: nextProps.history.location.state.search,
                                },
                            });
                        } else {
                            nextProps.account_management.login.data["2fa_required"] == 1 ||
                            nextProps.account_management.login.data.phone_number_validated ==
                            0
                                ? nextProps.history.push("/verify-mobile", {
                                    phone_number_validated: false,
                                    api_token:
                                    nextProps.account_management.login.data.api_token,
                                    token: nextProps.account_management.login.data.token,
                                    parentPath: {
                                        basePath: nextProps.history.location.state.basePath,
                                        search: nextProps.history.location.state.search,
                                    },
                                })
                                : setData(
                                LOGIN,
                                nextProps.account_management.login.data,
                                () => {
                                    nextProps.history.push("/dashboard");
                                }
                                );
                        }
                        doMoneyBloxLogin(this.state.moneyBloxData, this.props);
                        getData(LOGIN).then((data) => {
                            if (!isEmpty(data)) {
                                nextProps.getUserDetails(data.token, data.api_token);
                                nextProps.getFollowingList(data.token, data.api_token, "", "");
                            }
                        });
                    }
        );
      } else {
        //if the status_code received from the server is NOT 200 means there has been some error occurred
        vuepayAlert("error", nextProps.account_management.login.message);
      }

      nextProps.resetLogin();
    }
  }

  //this function helps to toggle the state of password
  showHidePassword = () => {
    this.setState({
        type: this.state.type === "input" ? "password" : "input",
        class_name:
            this.state.type === "input" ? "btn btn-pwd-hide" : "btn btn-pwd-show",
    });
  };

  onSubmit(values) {
    const data = {
      login: values.login,
      password: CryptoJS.MD5(values.password).toString(),
      device: this.props.device,
    };
    this.setState({
      moneyBloxData: data,
    });
    this.props.login(data);
  }

  render() {
      const {handleSubmit, location} = this.props;
      const basePath = _get(location, "state.basePath", "");

    return (
        <ModelTemp>
            <div>
                <main role="main" className="">
                    <input type="hidden" value="something"/>
                    <div className="login-container" id="vuepay_login">
                        <div className="popup-header">
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() =>
                                    // this.props.history.push(basePath)
                                {
                                    document.getElementsByClassName(
                                        "modal-overlay"
                                    )[0].style.display = "none";
                                    this.props.history.push({
                                        pathname: this.props.location.state.parentPath
                                            ? this.props.location.state.parentPath.basePath
                                            : this.props.location.state.basePath,
                                        search: this.props.location.state.parentPath
                                            ? this.props.location.state.parentPath.search
                                            : this.props.location.state.search,
                                        state: {
                                            basePath: this.props.location.state.parentPath
                                                ? this.props.location.state.parentPath.basePath
                                                : this.props.location.state.basePath,
                                            search: this.props.location.state.parentPath
                                                ? this.props.location.state.parentPath.search
                                                : this.props.location.state.search,
                                        },
                                    });
                                }
                                }
                            >
                                <img
                                    alt={"close-icon"}
                                    src={
                                        "https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"
                                    }
                                />
                            </button>
                        </div>
                        <div className="row">
                            <div
                                className="col-md-6 bg-primary d-flex align-items-center text-center"
                                style={{borderRight: "1px solid #e7e7e7"}}
                            >
                                <img
                                    src={vuepay_large_logo}
                                    className="img-fluid"
                                    alt={"VuePay logo"}
                                />
                            </div>
                            <div className="col-md-6 bg-white d-flex align-items-center">
                                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                    <h4>Welcome back!</h4>
                                    <Field
                                        label="Username or Email"
                                        name="login"
                                        type="text"
                                        height={"47px"}
                                        email={true}
                                        username={null}
                                        validate={[this.required]}
                                        component={renderField}
                                    />
                                    <br/>
                                    <Field
                                        label="Password"
                                        name="password"
                                        type={this.state.type}
                                        height={"47px"}
                                        username={null}
                                        is_password={true}
                                        password_class={this.state.class_name}
                                        buttonClick={this.showHidePassword}
                                        validate={[this.required]}
                                        component={renderField}
                                    />
                                    <br/>
                                    <div className="mt-4 text-center">
                                        <button className="btn btn-primary">
                                            {this.props.account_management.isFetching ? (
                                                <img
                                                    src={loading_white}
                                                    alt={"Loading"}
                                                    width={26}
                                                    height={26}
                                                />
                                            ) : (
                                                "Log In"
                                            )}
                                        </button>
                                        <br/>
                                        <Link
                                            to={{
                                                pathname: "/forgot-password",
                                                state: {
                                                    basePath: basePath,
                                                    parentPath: {
                                                        basePath: this.props.history.location.state
                                                            .basePath,
                                                        search: this.props.history.location.state.search,
                                                    },
                                                },
                                            }}
                                            className="mt-2 btn btn-link"
                                            role="button"
                                            title="Forgotten password?"
                                        >
                                            Forgotten password?
                                        </Link>
                                        <p className="mt-5">Don’t have an account</p>
                                        <Link
                                            to={{
                                                pathname: "/register",
                                                state: {
                                                    basePath: basePath,
                                                    parentPath: {
                                                        basePath: this.props.history.location.state
                                                            .basePath,
                                                        search: this.props.history.location.state.search,
                                                    },
                                                },
                                            }}
                                            className="btn btn-outline-primary signup"
                                        >
                                            Sign up
                                        </Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </ModelTemp>
    );
  }
}

function mapStateToProps(state) {
  return {
    account_management: state.account_management,
    device: state.device.payload,
  };
}

export default reduxForm({
  form: "LoginForm",
})(connect(mapStateToProps, actions)(Login));
